{
  "aiGeneratedAnswer": "Odpoveď generovaná AI",
  "allCategories": "Všetky kategórie",
  "appliedFiltersToCurrentSearch": "Použité filtre na aktuálne vyhľadávanie",
  "apply": "Použiť",
  "applyFilters": "Použiť filtre",
  "autocompleteOptionsFound_few": "Nájdené {{count}}{{label}} možnosti automatického dopĺňania.",
  "autocompleteOptionsFound_many": "Nájdených {{count}}{{label}} možností automatického dopĺňania.",
  "autocompleteOptionsFound_one": "Nájdená {{count}}{{label}} možnosť automatického dopĺňania.",
  "autocompleteOptionsFound_other": "Nájdených {{count}}{{label}} možností automatického dopĺňania.",
  "autocompleteSuggestion": "návrh automatického dopĺňania: {{suggestion}}",
  "autocompleteSuggestionsFound_few": "Nájdené {{count}} návrhy automatického dopĺňania.",
  "autocompleteSuggestionsFound_many": "Nájdených {{count}} návrhov automatického dopĺňania.",
  "autocompleteSuggestionsFound_one": "Nájdený {{count}} návrh automatického dopĺňania.",
  "autocompleteSuggestionsFound_other": "Nájdených {{count}} návrhov automatického dopĺňania.",
  "basedOnYourDevice": " (na základe vášho zariadenia)",
  "basedOnYourInternetAddress": " (na základe vašej internetovej adresy)",
  "categoriesText_few": "Nasledujúce kategórie priniesli výsledky pre – <strong>{{query}}</strong>",
  "categoriesText_one": "Nasledujúca kategória priniesla výsledky pre – <strong>{{query}}</strong>",
  "categoriesText_other": "Nasledujúcych kategórií prinieslo výsledky pre – <strong>{{query}}</strong>",
  "clearAll": "Vymazať všetko",
  "clearMinAndMax": "Vymazať min a max",
  "clearTheRangeToSelectOptions": "Vymazať rozsah na výber možností.",
  "clearTheSearchBar": "Vymazať vyhľadávací panel",
  "conductASearch": "Vykonať vyhľadávanie",
  "currentLocation": "Aktuálna poloha",
  "didYouMean": "Mali ste na mysli <button>{{correctedQuery}}</button>?",
  "dropDownScreenReaderInstructions": "Keď sú k dispozícii výsledky automatického dokončenia, použite šípky nahor a nadol na preskúmanie a enter na výber.",
  "feedback": "Spätná väzba",
  "filterGroupSearchInputLabel": "Hľadať možnosti {{title}}",
  "invalidRange": "Neplatný rozsah",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Prejsť na ďalšiu stránku výsledkov",
  "navigateToThePreviousResultsPage": "Prejsť na predchádzajúcu stránku výsledkov",
  "noAutocompleteOptionsFound": "0 nájdených možností automatického dokončenia.",
  "noAutocompleteSuggestionsFound": "0 nájdených návrhov automatického dokončenia.",
  "noResultsFoundIn": "Nenašli sa žiadne výsledky v {{currentVerticalLabel}}.",
  "paginationPage": "strana {{pageNumber}}",
  "pagination": "Stránkovanie",
  "readMoreAbout": "Čítať viac o <a>{{name}}</a>",
  "recentSearch": "nedávne vyhľadávanie: {{query}}",
  "recentSearchesFound_few": "Nájdené {{count}} nedávne vyhľadávania.",
  "recentSearchesFound_many": "Nájdených {{count}} nedávnych vyhľadávaní.",
  "recentSearchesFound_one": "Nájdené {{count}} nedávne vyhľadávanie.",
  "recentSearchesFound_other": "Nájdených {{count}} nedávnych vyhľadávaní.",
  "removeFilter": "Odstrániť filter „{{displayName}}“",
  "resultPreview": "výsledkový náhľad: {{value}}",
  "resultPreviewsFound_few": "Nájdené {{count}} náhľady výsledkov.",
  "resultPreviewsFound_many": "Nájdených {{count}} náhľadov výsledkov.",
  "resultPreviewsFound_one": "Nájdený {{count}} náhľad výsledku.",
  "resultPreviewsFound_other": "Nájdených {{count}} náhľadov výsledkov.",
  "resultsCountText_few": "{{count}} výsledky",
  "resultsCountText_many": "{{count}} výsledkov",
  "resultsCountText_one": "{{count}} výsledok",
  "resultsCountText_other": "{{count}} výsledkov",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} z {{resultsCount}} výsledkov",
  "searchHere": "Vyhľadajte tu…",
  "showingAllInstead": "Zobrazujú sa všetky položky v {{currentVerticalLabel}}.",
  "showLess": "Zobraziť menej",
  "showMore": "Zobraziť viac",
  "sources_few": "Zdroje ({{count}})",
  "sources_many": "Zdroje ({{count}})",
  "sources_one": "Zdroj",
  "sources_other": "Zdroje ({{count}})",
  "submitSearch": "Odovzdať",
  "suggestionResultsCount_few": "{{label}} – {{count}} výsledky",
  "suggestionResultsCount_many": "{{label}} – {{count}} výsledkov",
  "suggestionResultsCount_one": "{{label}} – {{count}} výsledok",
  "suggestionResultsCount_other": "{{label}} – {{count}} výsledkov",
  "thankYouForYourFeedback": "Ďakujeme za vašu spätnú väzbu!",
  "thisAnsweredMyQuestion": "Toto odpovedalo na moju otázku",
  "thisDidNotAnswerMyQuestion": "Toto neodpovedalo na moju otázku",
  "unselectAnOptionToEnterInARange": "Zrušte výber možnosti, aby ste mohli zadať rozsah.",
  "updateYourLocation": "Aktualizujte svoju polohu",
  "useCurrentLocation": "Použiť aktuálnu polohu",
  "useMyLocation": "Použiť moju polohu",
  "viewAll": "Zobraziť všetko",
  "viewDetails": "Zobraziť podrobnosti"
}
